import React from 'react';
import '../css.css';

const AdminModal = ({ isOpen, onClose, type, title, message, onConfirm }) => {
    if (!isOpen) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        onClose();
    };

    const getIconByType = () => {
        switch (type) {
            case 'success':
                return '✅';
            case 'error':
                return '❌';
            case 'warning':
                return '⚠️';
            case 'confirm':
                return '❓';
            default:
                return 'ℹ️';
        }
    };

    const getColorByType = () => {
        switch (type) {
            case 'success':
                return '#28a745';
            case 'error':
                return '#dc3545';
            case 'warning':
                return '#ffc107';
            case 'confirm':
                return '#007bff';
            default:
                return '#6c757d';
        }
    };

    return (
        <div className="admin-modal-overlay" onClick={handleOverlayClick}>
            <div className="admin-modal">
                <div className="admin-modal-header" style={{ borderTopColor: getColorByType() }}>
                    <div className="admin-modal-icon" style={{ color: getColorByType() }}>
                        {getIconByType()}
                    </div>
                    <h3 className="admin-modal-title">{title}</h3>
                </div>
                
                <div className="admin-modal-body">
                    <p className="admin-modal-message">{message}</p>
                </div>
                
                <div className="admin-modal-footer">
                    {type === 'confirm' ? (
                        <>
                            <button 
                                className="admin-modal-button cancel"
                                onClick={onClose}
                            >
                                취소
                            </button>
                            <button 
                                className="admin-modal-button confirm"
                                onClick={handleConfirm}
                                style={{ backgroundColor: getColorByType() }}
                            >
                                확인
                            </button>
                        </>
                    ) : (
                        <button 
                            className="admin-modal-button confirm"
                            onClick={onClose}
                            style={{ backgroundColor: getColorByType() }}
                        >
                            확인
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminModal;
